import { Numeric9PlusBoxOutlineIcon } from './Numeric9PlusBoxOutlineIcon';

/**
 * author: Google
 * id C1F38C40-BD01-45FE-A94C-B3C1432707E0
 * name numeric-9-plus-box-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/numeric-9-plus-box-outline.svg
 * tags
 * - Alpha / Numeric 
 */
export const NumericNinePlusBoxOutlineIcon = Numeric9PlusBoxOutlineIcon;
export default NumericNinePlusBoxOutlineIcon